import { all, call, put } from 'redux-saga/effects';
import { httpRequest } from 'utils/http';
import sagaListen from 'utils/sagaListen';

import { FETCH_SUBSCRIPTION_PLANS } from 'containers/SubscriptionPlans/constants';
import { fetchSubscriptionPlans } from 'containers/SubscriptionPlans/model';

import {
  fetchSubscriptionPlansError,
  fetchSubscriptionPlansSuccess,
} from 'containers/SubscriptionPlans/actions';

export function* fetchSubscriptionPlansSaga() {
  try {
    const plans = yield call(httpRequest, fetchSubscriptionPlans);
    yield put(fetchSubscriptionPlansSuccess(plans));
  } catch (error) {
    yield put(fetchSubscriptionPlansError(error));
  }
}

export default function* defaultSaga() {
  yield all([
    call(sagaListen, FETCH_SUBSCRIPTION_PLANS, fetchSubscriptionPlansSaga),
  ]);
}
